import React from 'react';
import {
  Box
} from '@mui/material';
import EditTradePartner from '../component/trade-partner-form/edit/EditTradePartner';

function ViewPage({ history, match: { params } }) {
  return (
    <Box>
      <EditTradePartner readOnly id={params.id} />
    </Box>
  );
};

export default ViewPage;